var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    { ref: "copyRef", staticClass: "qm-copy" },
    [
      _vm.$slots.default
        ? [_vm._t("default")]
        : [
            _vm.type === "icon"
              ? [
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.status === "normal",
                        expression: "status === 'normal'",
                      },
                    ],
                    staticClass: "qm-copy__icon qm-icon-copy",
                  }),
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.status === "success",
                        expression: "status === 'success'",
                      },
                    ],
                    staticClass:
                      "qm-copy__icon qm-copy__icon--success qm-icon-success-fill",
                  }),
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.status === "fail",
                        expression: "status === 'fail'",
                      },
                    ],
                    staticClass:
                      "qm-copy__icon qm-copy__icon--fail qm-icon-warning-fill",
                  }),
                ]
              : [
                  _c("span", { staticClass: "qm-copy__reference" }, [
                    _vm._v("复制"),
                  ]),
                ],
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }